import { render, staticRenderFns } from "./ChampMeet.vue?vue&type=template&id=1d4cf680&"
import script from "./ChampMeet.vue?vue&type=script&lang=js&"
export * from "./ChampMeet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports